module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "cashierdetail"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    staticClass: "first",
    attrs: {
      "to": {
        path: '/main/cashiermanage'
      },
      "replace": ""
    }
  }, [_vm._v("收银员管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("查看详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("账户状态")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-color": "#FF8100",
      "off-color": "#d8d8d8",
      "on-value": "1",
      "off-value": "0"
    },
    on: {
      "change": _vm.changeStatus
    },
    model: {
      value: (_vm.opinfo.status),
      callback: function($$v) {
        _vm.$set(_vm.opinfo, "status", $$v)
      },
      expression: "opinfo.status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("门店")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("主账号")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("收银员编号")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opuid))])]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "info next-bottom"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("退款权限")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-color": "#7ed321",
      "off-color": "#d8d8d8",
      "on-value": "1",
      "off-value": "0"
    },
    on: {
      "change": _vm.changeRights
    },
    model: {
      value: (_vm.opinfo.refund),
      callback: function($$v) {
        _vm.$set(_vm.opinfo, "refund", $$v)
      },
      expression: "opinfo.refund"
    }
  })], 1)]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-btn-group__wrapper"
  }, [_c('a', {
    attrs: {
      "href": _vm.downHref,
      "download": ""
    }
  }, [_vm._m(4, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_record",
    on: {
      "click": _vm.changeInfo
    }
  }, [_c('span', [_vm._v("编辑收银员资料")])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑收银员资料",
      "visible": _vm.showChangeInfo,
      "custom-class": "mydialog",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangeInfo = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "opname"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入收银员姓名"
    },
    model: {
      value: (_vm.form.opname),
      callback: function($$v) {
        _vm.$set(_vm.form, "opname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.opname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入收银员电话"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主账号"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收银员编号"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.opuid))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收银员密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入收银员密码",
      "id": "end-length"
    },
    on: {
      "change": _vm.passChange,
      "blur": _vm.passBlur,
      "focus": _vm.passFocus
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showChangeInfo = false
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("确 认")])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("收银员资料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info next-bottom"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("收银员密码")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v("******")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 收银员登陆方式为主账号+收银员编号+收银员密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 目前收银员仅支持查看活动信息，不支持对红包、集点、储值活动、特卖、店铺公告、会员特权的增删改")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail"
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', [_vm._v("下载收款码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfaa0ad6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cashierdetail/cashierdetail.vue
// module id = 837
// module chunks = 1